import { styled, Typography } from '@mui/material'
import { CircularLoading } from '$common/loading/circular-loading'
import { t } from '$i18n'

export function PendingWappLoading() {
  return (
    <Root>
      <LoadingContainer>
        <StyledCircularLoading
          rootSx={{
            margin: 0,
          }}
        />
      </LoadingContainer>
      <Typography variant="subtitle1" color="neutral700">
        {t('common.uploading')}
      </Typography>
    </Root>
  )
}

const StyledCircularLoading = styled(CircularLoading)`
  color: ${({ theme }) => theme.palette.primary500};
  width: 20px !important;
  height: 20px !important;
`

const LoadingContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.neutral000};
  width: 52px;
  height: 52px;
  border-radius: 50%;
`

const Root = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.neutral100};
  flex-direction: column;
  gap: 20px;
`
